<template>
  <v-list dense>
        <v-list-item-group v-model="group" mandatory>
          <template v-for="item in items">
            <div v-if="canDisplayMenuItem(item)" v-bind:key="item.key" data-testid="contacts-drawer-tagsgroup">
              <v-row v-if="item.spacer" :key="item.key" align="center">
                <br/><br/><v-divider></v-divider><br/><br/>
              </v-row>
              <v-list-group
                v-else-if="item.children"
                :key="item.text"
                :prepend-icon="item['icon-alt']"
                append-icon=""
              >
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ item.text }}
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-list-item
                  v-for="(child, i) in item.children"
                  :key="i"
                  link
                  :class="$vuetify.theme.dark ? 'custom-list-item-dark' : 'custom-list-item-light'"
                  v-show="child.key === 'create_personal_tag' || (child.key === 'create_tag' && canContactsWrite)"
                  @click="openTagForm({tag: null, isPersonal: child.key === 'create_personal_tag', isUpdate: false})"
                >
                  <v-list-item-action v-if="child.icon">
                    <v-icon>{{ child.icon }}</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ child.text }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider/>
                <!-- TAG -->
                <TagsList :item="item"/>
                <!-- PERSONAL TAG -->
                <PersonalTagsList :item="item"/>

              </v-list-group>
              <v-list-item
                v-else
                :key="item.text"
                link
                data-testid="contacts-drawer-simplelist"
                @click="onDrawerItemClick(item)"
              >
                <v-list-item-action>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.text }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </div>
          </template>
        </v-list-item-group>
      </v-list>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import API from '@/api'
import Tag from 'Store/class/contact/tag'
import PersonalTag from 'Store/class/contact/personal_tag'
import PersonalTagsList from './personal_tags_list'
import TagsList from './tags_list'
export default {
  name: 'contacts-drawer',
  components: {
    PersonalTagsList,
    TagsList
  },
  data () {
    return {
      group: null,
      items: [
        { icon: 'mdi-domain', text: this.$t('contacts.btn.sharedContacts'), key: 'shared_contacts', selected: !this.filterByPersonal },
        { icon: 'mdi-account-outline', text: this.$t('contacts.btn.personalContacts'), key: 'personal_contacts', selected: this.filterByPersonal },
        { spacer: true, key: 'spacer0' },
        {
          icon: 'mdi-chevron-up',
          'icon-alt': 'mdi-chevron-down',
          key: 'tags',
          text: this.$t('contacts.columns.tags'),
          model: true,
          children: [
            { icon: 'mdi-plus', text: this.$t('contacts.btn.createTag'), key: 'create_tag' }
          ]
        },
        {
          icon: 'mdi-chevron-up',
          'icon-alt': 'mdi-chevron-down',
          key: 'personal_tags',
          text: this.$t('contacts.columns.personalTags'),
          model: true,
          children: [
            { icon: 'mdi-plus', text: this.$t('contacts.btn.createPersonalTag'), key: 'create_personal_tag' }
          ]
        },
        { spacer: true, key: 'spacer1' },
        { icon: 'mdi-import', text: this.$t('contacts.btn.import'), key: 'import' },
        { icon: 'mdi-export', text: this.$t('contacts.btn.export'), key: 'export' }
      ]
    }
  },
  computed: {
    ...mapGetters({
      canContactsRead: 'permissions/contactsRead',
      canContactsWrite: 'permissions/contactsWrite',
      canContactsManagePersonal: 'permissions/contactsManagePersonal',
      getIsPersonal: 'contacts/isPersonal',
      tags: 'contacts/tags/tags',
      personalTags: 'contacts/personalTags/personalTags',
      getFilterByTags: 'contacts/filterByTags',
      getFilterByPersonalTags: 'contacts/filterByPersonalTags'
    }),
    filterByPersonal: { get () { return this.getIsPersonal }, set (isPersonal) { this.setIsPersonal(isPersonal) } },
    filterByTags: { get () { return this.getFilterByTags }, set (filterByTags) { this.setFilterByTags(filterByTags) } },
    filterByPersonalTags: { get () { return this.getFilterByPersonalTags }, set (filterByPersonalTags) { this.setFilterByPersonalTags(filterByPersonalTags) } }
  },
  methods: {
    ...mapActions({
      setIsPersonal: 'contacts/setIsPersonal',
      getContacts: 'contacts/get',
      getTags: 'contacts/tags/get',
      getPersonalTags: 'contacts/personalTags/get',
      openTagDialog: 'contacts/tagForm/open',
      openDeleteDialog: 'contacts/tagDeleteForm/open',
      openContactForm: 'contacts/form/open',
      setFilterByTags: 'contacts/setFilterByTags',
      setFilterByPersonalTags: 'contacts/setFilterByPersonalTags',
      openImportDialog: 'contacts/importForm/open'
    }),

    openTagForm (params) {
      const isPersonal = params.isPersonal
      const isUpdate = params.isUpdate
      let tag = null
      if (isUpdate) {
        tag = params.tag
      } else {
        tag = isPersonal ? new PersonalTag({ id: null, name: '' }) : new Tag({ id: null, name: '' })
      }
      this.openTagDialog({ tag, isPersonal, isUpdate })
    },

    canDisplayMenuItem (item) {
      // const menuDislayedEveytime = (item.key !== 'personal_contacts' && item.key !== 'personal_tags' && item.key !== 'import')
      const filterShared = (item.key === 'shared_contacts' || item.key === 'tags') && this.canContactsRead
      const filterPersonal = (item.key === 'personal_contacts' || item.key === 'personal_tags') && this.canContactsManagePersonal
      const filterImport = item.key === 'import' && (this.canContactsManagePersonal || this.canContactsWrite)
      const filterExport = item.key === 'export' && (this.canContactsManagePersonal || this.canContactsRead)
      return filterShared || filterPersonal || filterImport || filterExport
    },

    downloadExportCsv () {
      API.exportContacts().then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'contacts.csv')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      })
    },

    onDrawerItemClick (item) {
      switch (item.key) {
        case 'shared_contacts':
          this.filterByPersonal = false
          this.filterByTags = []
          this.filterByPersonalTags = []
          break
        case 'personal_contacts':
          this.filterByPersonal = true
          this.filterByTags = []
          this.filterByPersonalTags = []
          break
        case 'tag_item':
          this.filterByPersonal = false
          this.filterByTags = [item.id]
          this.filterByPersonalTags = []
          break
        case 'export':
          this.downloadExportCsv()
          break
        case 'import':
          this.openImportDialog()
          break
      }
    },
    resetContactView () {
      this.filterByPersonal = false
      this.filterByTags = []
      this.filterByPersonalTags = []
    }
  },
  mounted () {
    this.resetContactView()
  }
}
</script>

<style>
.custom-list-item-dark {
  background-color: #424242;
}
.custom-list-item-light {
  background-color: #F5F5F5;
}
</style>
